// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_Y-Y","cls2":"WorkSelectorUpload-cls2_iGw WorkSelectorUpload-cls1_Y-Y"};